import { Box, Typography } from '@mui/material'
import { InfoTooltip, useI18n } from '@popety_io/popety-io-lib'
import AcUnitIcon from '@mui/icons-material/AcUnit'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import { InfoOutlined } from '@mui/icons-material'

import { ContentTitleItemRoot } from '../EstimateNoise/components/NightAndDay/NightAndDay.style'

const EstimateSunlightHeader = ({ data }: { data: any }) => {
  const { t } = useI18n()

  const options = [
    {
      icon: (
        <WbSunnyIcon
          fontSize="large"
          sx={{
            color: '#FBD823',
          }}
        />
      ),
      title: t('common.ete'),
      hoursTile: t('estimate.Durée du jour maximum en été'),
      hours: data.sunlightSummerHours
        ? `${Math.floor(data.sunlightSummerHours)}h`
        : 'N/A',
    },
    {
      icon: <AcUnitIcon fontSize="large" />,
      title: t('common.hiver'),
      hoursTile: t('estimate.Durée du jour maximum en hiver'),
      hours: data.sunlightWinterHours
        ? `${Math.floor(data.sunlightWinterHours)}h`
        : 'N/A',
    },
  ]

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      {options.map((item, key) => {
        return (
          <Box
            key={`noise_${key}`}
            sx={{
              display: 'flex',
              marginBottom: '10px',
              justifyContent: 'space-between',
              fontWeight: 500,
              gap: 8,
              flexDirection: 'row',
              flexGrow: 1,
            }}
          >
            <Box display="flex" flexDirection="column" gap={2}>
              <Box display="flex" alignItems="center" gap={1}>
                {item.icon}
                <span style={{ textTransform: 'uppercase' }}>{item.title}</span>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ContentTitleItemRoot>
                <Typography variant="h4" fontWeight={500}>
                  {item.hours}
                </Typography>

                <Typography display="flex" alignItems="center">
                  {item.hoursTile}
                  <InfoTooltip infos={[{ text: 'Content' }]}>
                    <InfoOutlined
                      sx={{ fill: '#969696', fontSize: 12, marginLeft: 0.5 }}
                    />
                  </InfoTooltip>
                </Typography>
              </ContentTitleItemRoot>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default EstimateSunlightHeader
